import { render, staticRenderFns } from "./MyPorts.vue?vue&type=template&id=cc0c851a&scoped=true"
import script from "./MyPorts.vue?vue&type=script&lang=js"
export * from "./MyPorts.vue?vue&type=script&lang=js"
import style0 from "./MyPorts.vue?vue&type=style&index=0&id=cc0c851a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0c851a",
  null
  
)

export default component.exports